import React from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Page from "src/components/Page";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  submitButton: {
    background: "#FD6A02",
    color: "#fff",
    "&$buttonDisabled": {
      color: theme.palette.text.disabled,
      background: theme.palette.background.paper,
    },
    "&:hover": {
      background: "#FD6A02",
      color: "#fff",
    },
  },
  backendresponse: {
    textAlign: "center",
    color: "#DB162F",
  },
}));

const LoginView = (props) => {
  const classes = useStyles();

  let {
    values: { email, password },
    errors,
    touched,
    handleBlur,
    isValid,
    dirty,
    handleSubmit,
    handleChange,
    authStatus,
  } = props;

  return (
    <Page className={classes.root} title="Login">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <form onSubmit={handleSubmit}>
            <Box mb={3}>
              <Typography color="textPrimary" variant="h2" align="center">
                Admin Sign in
              </Typography>
            </Box>

            <TextField
              error={Boolean(touched.email && errors.email)}
              fullWidth
              helperText={touched.email && errors.email}
              label="Email Address"
              margin="normal"
              name="email"
              onBlur={handleBlur}
              onChange={handleChange}
              type="email"
              value={email}
              variant="outlined"
            />
            <TextField
              error={Boolean(touched.password && errors.password)}
              fullWidth
              helperText={touched.password && errors.password}
              label="Password"
              margin="normal"
              name="password"
              onBlur={handleBlur}
              onChange={handleChange}
              type="password"
              value={password}
              variant="outlined"
            />
            {authStatus.success === false ? (
              <Typography className={classes.backendresponse}>
                {authStatus.message}
              </Typography>
            ) : (
              ""
            )}
            <Box my={2}>
              <Button
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                disabled={!(isValid && dirty)}
                classes={{
                  root: classes.submitButton,
                  disabled: classes.buttonDisabled,
                }}
              >
                Sign in now
              </Button>
            </Box>
          </form>
        </Container>
      </Box>
    </Page>
  );
};

export default LoginView;
